import { render, staticRenderFns } from "./AdminCoupons.vue?vue&type=template&id=10ed7332&"
import script from "./AdminCoupons.vue?vue&type=script&lang=js&"
export * from "./AdminCoupons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports